import styled from "styled-components";

export const ImplantReportContainer = styled.div`
  display: flex;
  flex-direction: column;
`;
